<template>
  <CBox
    :bg="['none', 'var(--colors-light-primary-light-gray)']"
    minHeight="100vh"
    width="100vw"
    position="sticky"
  >
    <OmtLayoutContainer>
      <OmtRow :mb="['26px', '32px']">
        <OmtTypography as="h1-bold"> {{ descricaoEspecialidade }} </OmtTypography>
      </OmtRow>
      <OmtRow
        v-for="(spec, idx) in subSpecialities"
        :key="'spec-' + idx"
      >
        <OmtTile
          cursor="pointer"
          :divider="idx !== subSpecialities.length - 1"
          @click="handleClick(spec)"
        >
          <OmtTypography as="h2-semi-bold">
            {{ capitalizeWords(spec.Descricao) }}
          </OmtTypography>
        </OmtTile>
      </OmtRow>
      <OmtRow
        v-if="showAffiliateIndication"
        mt="42px"
        @click="redirectToAffiliateIndication"
      >
        <CBox
          bg="var(--colors-light-primary-light-gray)"
          py="14px"
          px="16px"
          border-radius="12px"
        >
          <OmtTile
            :divider="false"
            icon="lightbulb"
          >
            <OmtTypography
              as="h2-bold"
              max-w="235px"
            >
              Gostaria de uma indicação de um especialista?
            </OmtTypography>
          </OmtTile>
        </CBox>
      </OmtRow>
    </OmtLayoutContainer>
  </CBox>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "SpecialitiesList",
  beforeRouteEnter(_, from, next) {
    next(vm => {
      vm.prevRoute = from.path;
    });
  },
  data() {
    return {
      prevRoute: "/redecredenciada/especialidades/",
      inputText: ""
    };
  },
  async mounted() {
    if (!this.group || !this.codigoEspecialidade) {
      await this.$router.replace({ name: "affiliate" });
      return;
    }
    try {
      this.$root.$emit("change-title-label", this.capitalizeWords(this.group));
      this.$root.$emit("change-back-route", "/redecredenciada/especialidades");
      await this.$root.$emit("show-loading");
      if (this.prevRoute === "/redecredenciada/especialidades") {
        await this.fetchSubSpecialities();
        if (!this.subSpecialities?.length) {
          // mas sem sub especialidade, pode ir para a tela de resultados direto
          this.SET_SUB_SPECIALITY({ cod: "", label: "" });
          this.$router.replace({ name: "affiliate.docs" });
        }
      } else if (!this.subSpecialities?.length) {
        // voltar, mas sem sub especialidade
        this.$router.replace({ name: "affiliate.specs" });
      }
    } catch (error) {
      this.$toast({
        description: error instanceof Error ? error.message : error,
        status: "error",
        duration: 10000,
        position: "top"
      });
    } finally {
      await this.$root.$emit("hide-loading");
    }
  },
  computed: {
    ...mapState("affiliate", [
      "subSpecialities",
      "group",
      "codigoEspecialidade",
      "descricaoEspecialidade",
      "tipoAtendimento",
      "allowAffiliateIndication"
    ]),
    showAffiliateIndication() {
      if (!this.allowAffiliateIndication) return false;
      return this.tipoAtendimento === "mediclin" || this.tipoAtendimento === "terapia";
    }
  },
  methods: {
    ...mapActions("affiliate", ["fetchSubSpecialities"]),
    ...mapMutations("affiliate", ["SET_SUB_SPECIALITY"]),
    handleClick(spec) {
      this.SET_SUB_SPECIALITY({ cod: spec.Codigo, label: spec.Descricao });
      this.$router.push({ name: "affiliate.docs" });
    },
    redirectToAffiliateIndication() {
      this.$router.push({ name: "indication" });
    },
    capitalizeWords(inputString) {
      return inputString.charAt(0).toUpperCase() + inputString.slice(1).toLowerCase();
    }
  }
};
</script>
